/**
 * Time zones a store can pick for midnight price activation (flag
 * `midnight_price_activation`). US and Canada cover the dealers Motzu serves;
 * the server accepts any IANA zone, and a zone it derived that is not listed
 * here is still shown as the current value.
 */
export const STORE_TIME_ZONES: Array<{ value: string; label: string }> = [
  { value: 'America/New_York', label: 'Eastern (New York)' },
  { value: 'America/Detroit', label: 'Eastern (Detroit)' },
  { value: 'America/Indiana/Indianapolis', label: 'Eastern (Indianapolis)' },
  { value: 'America/Toronto', label: 'Eastern (Toronto)' },
  { value: 'America/Chicago', label: 'Central (Chicago)' },
  { value: 'America/Winnipeg', label: 'Central (Winnipeg)' },
  { value: 'America/Regina', label: 'Central, no daylight time (Regina)' },
  { value: 'America/Denver', label: 'Mountain (Denver)' },
  { value: 'America/Boise', label: 'Mountain (Boise)' },
  { value: 'America/Edmonton', label: 'Mountain (Edmonton)' },
  { value: 'America/Phoenix', label: 'Mountain, no daylight time (Phoenix)' },
  { value: 'America/Los_Angeles', label: 'Pacific (Los Angeles)' },
  { value: 'America/Vancouver', label: 'Pacific (Vancouver)' },
  { value: 'America/Anchorage', label: 'Alaska (Anchorage)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii (Honolulu)' },
  { value: 'America/Halifax', label: 'Atlantic (Halifax)' },
  { value: 'America/Moncton', label: 'Atlantic (Moncton)' },
  { value: 'America/St_Johns', label: 'Newfoundland (St. John\'s)' },
  { value: 'America/Puerto_Rico', label: 'Atlantic, no daylight time (Puerto Rico)' },
  { value: 'America/Whitehorse', label: 'Yukon (Whitehorse)' },
  { value: 'America/Yellowknife', label: 'Mountain (Yellowknife)' },
  { value: 'America/Iqaluit', label: 'Eastern (Iqaluit)' },
];
